import React, { FC } from "react"
import { TypeNewForm, TypeNewFormProps } from "../common/newType"

type NewProductTypeFormProps = Omit<TypeNewFormProps, "placeholder">;

export const ProductTypeNewForm: FC<NewProductTypeFormProps> = (props) => {
  return <TypeNewForm {...props} placeholder="New Product Category Name" />
}
